import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTarget, FiTrendingUp, FiAlertTriangle, FiCheckCircle } = FiIcons;

const Hero = () => {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
              Why <span className="text-yellow-300">RETURNS</span> Matter More
              <br className="hidden sm:block" />
              <span className="block sm:inline"> Than </span>
              <span className="text-yellow-300">"Goal Labels"</span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 text-indigo-100 px-2">
              Discover how choosing the RIGHT fund category for each goal can save you years of delay
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mt-8 sm:mt-12"
          >
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-white/20 hover:bg-white/15 transition-all">
              <SafeIcon icon={FiTarget} className="text-3xl sm:text-4xl mb-3 sm:mb-4 mx-auto text-yellow-300" />
              <h3 className="text-base sm:text-lg font-semibold mb-2">Goal-Based Planning</h3>
              <p className="text-indigo-100 text-sm leading-relaxed">
                Your goal decides the timeframe, timeframe decides the fund category
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-white/20 hover:bg-white/15 transition-all">
              <SafeIcon icon={FiTrendingUp} className="text-3xl sm:text-4xl mb-3 sm:mb-4 mx-auto text-green-300" />
              <h3 className="text-base sm:text-lg font-semibold mb-2">Returns Impact</h3>
              <p className="text-indigo-100 text-sm leading-relaxed">
                See how fund choice affects your goals - early achievement or years of delay
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-white/20 hover:bg-white/15 transition-all sm:col-span-2 lg:col-span-1">
              <SafeIcon icon={FiAlertTriangle} className="text-3xl sm:text-4xl mb-3 sm:mb-4 mx-auto text-orange-300" />
              <h3 className="text-base sm:text-lg font-semibold mb-2">Mismatch Cost</h3>
              <p className="text-indigo-100 text-sm leading-relaxed">
                Understand the hidden cost of putting long-term goals in short-term funds
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-8 sm:mt-12"
          >
            <div className="bg-yellow-400 text-gray-900 rounded-lg p-3 sm:p-4 inline-block max-w-full">
              <div className="flex items-center justify-center space-x-2 flex-wrap">
                <SafeIcon icon={FiCheckCircle} className="text-lg sm:text-xl flex-shrink-0" />
                <span className="font-medium text-xs sm:text-sm text-center">
                  Created by Gopi Krishna - SEBI Registered Research Analyst (INH000010858)
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;